import { createSuitMixin as e } from "../mixins/suit.js";
import { createWidgetMixin as t } from "../mixins/widget.js";
import { connectRelevantSort as i } from "instantsearch.js/es/connectors/index.js";
export default {
  name: "AisRelevantSort",
  mixins: [e({
    name: "RelevantSort"
  }), t({
    connector: i
  }, {
    $$widgetType: "ais.relevantSort"
  })],
  methods: {
    refine: function refine() {
      this.state.isRelevantSorted ? this.state.refine(0) : this.state.refine(void 0);
    }
  }
};